module.exports = __webpack_public_path__ + "img/broker_logo_gallagher.00f0a8b5.png";